import {
  CreateUpdatePrispevok,
  Priloha,
  PrispevokVestnikaUpdateApi,
} from 'vestniky-frontend-ts-axios';
import { ClientResponse } from '../model/types/ClientResponse';
import apiConfiguration from './configuration/apiConfiguration';
import PrispevokVestnika from '../model/PrispevokVestnika';
import dateToString from '../function/dateToString';
import PrilohaVestnika from '../model/PrilohaVestnika';
import { vestnikyPrefixPath } from './configuration/apiConfigurationConstants';

const client = new PrispevokVestnikaUpdateApi(apiConfiguration(vestnikyPrefixPath));

const map = (prispevok: PrispevokVestnika): CreateUpdatePrispevok => ({
  uuid: prispevok.uuid,
  nazov: prispevok.nazov,
  cislo: prispevok.cislo,
  datumZverejnenia: prispevok.datumZverejnenia ? dateToString(prispevok.datumZverejnenia) : null,
  kratkyNazov: prispevok.kratkyNazov,
  datumUcinnosti: prispevok.datumUcinnosti ? dateToString(prispevok.datumUcinnosti) : null,
  popis: prispevok.popis,
  meniPrispevky: prispevok.meniPrispevky?.map(predpis => predpis.uuid),
  rusiPrispevky: prispevok.rusiPrispevky?.map(predpis => predpis.uuid),
  vykonavaciePredpisy: prispevok.vykonavaciePredpisy?.map(predpis => predpis.iri),
  prilohy: prispevok.prilohy?.map(priloha => mapPriloha(priloha)),
  activeStep: null,
});

const mapPriloha = (priloha: PrilohaVestnika): Priloha => ({
  uuid: priloha.uuid,
  subor: priloha.fileBase64,
  hlavna: priloha.hlavna,
  nazovSuboru: priloha.nazovSuboru,
  originalFilename: priloha.file?.name,
});

// eslint-disable-next-line import/prefer-default-export
export const updatePrispevokVestnika = async (
  prispevok: PrispevokVestnika,
  options?: { headers?: object },
):
  Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.updatePrispevokVestnika(prispevok.uuid, map(prispevok), options);
  return {
    responseCode: status,
  };
};
